import { render, staticRenderFns } from "./imagePreview.vue?vue&type=template&id=4ddd5084"
import script from "./imagePreview.vue?vue&type=script&lang=js"
export * from "./imagePreview.vue?vue&type=script&lang=js"
import style0 from "./imagePreview.vue?vue&type=style&index=0&id=4ddd5084&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports